// extracted by mini-css-extract-plugin
export default {"wrapper":"OA-z","viewport":"PA-z","container":"QA-z","slide":"RA-z"};